export const pathUrl = {
  loanProductShelf: '/loan-product-shelf',
  loanApply: {
    apply: '/loan-apply',
    productDetail: '/loan-apply/product-detail',
    calculation: '/loan-apply/loan-calculation',
  },
  personalInformation: '/personal/personal-information',
  additionalInformation: '/personal/additional-information',
  editInformation: '/edit-information',
  confirmingDetails: '/confirming-details',
  marketingConsent: '/marketing-consent',
  ncbConsent: '/ncb-consent',
  loanApplyVerifying: '/loan-apply-verify',
  loanApplyError: '/loan-apply-error',
  confirmSummary: '/confirm-summary',
};
